// extracted by mini-css-extract-plugin
export default {"close":"Close_close__PXOVc"};